import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import { useState } from "react";
import RouteModal from "../../Component/BasicComponents/Modal/RouteModal";
import { FaEdit, FaEye } from "react-icons/fa";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import BrandCampaginModalContent from "./ModalContent/BrandCampaginModalContent";
import {
  useAddBrandCampaign,
  useBrandCampaignListData,
  usePublishBrandCampaignStatusChange,
  useUpdateBrandCampaign,
} from "./hooks/useBrandCampaign";
import { useNavigate } from "react-router-dom";
import { LiaStoreAltSolid } from "react-icons/lia";
import { BsSortNumericUp } from "react-icons/bs";
import { FaRegPlayCircle } from "react-icons/fa";

import Loader from "../../assets/loader/loader.gif";
import { showToast } from "../../utils/toastUtils";
type Props = {};

const BrandCampagin = (props: Props) => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalStatus, setModalStatus] = useState<any>("");
  const [selectedRow, setSelectedRow] = useState<any>("");
  const [filtersState, setFiltersState] = useState<any>({
    Orgunitid: null,
    search: "",
    start: 1,
    length: 10,
    sortColumn: null,
    sortOrder: null,
  });
  const [formData, setFormData] = useState({
    campaignName: "",
    campaignCode: "",
    startDate: "",
    endDate: "",
    lockingDate: "",
    campaignType: "",
    outletTypeId: "",
    focusBrands: [],
    sgpiBrands: [],
    isSuspended: "",
    orgUnit: "",
    classifications: [],
    minValues: [],
    maxValues: [],
    position: [],
    description: "",
    materialUrl: "",
    media: "",
    Grades: [],
  });

  const [brandCampaignId, setBrandCampaignId] = useState(null);
  const [orgUnitId, setOrgUnitId] = useState(null);
  const [shouldOpenModal, setShouldOpenModal] = useState(false);
  const [buttonDisable, setButtonDisable] = useState(false);

  const orgunitss = formData?.orgUnit === "" ? orgUnitId : formData?.orgUnit;

  const { mutate: addBrandCampaign } = useAddBrandCampaign();
  const { mutate: updateBrandCampaign } = useUpdateBrandCampaign();
  const { mutate: publishBrandCampaignStatusChange } =
    usePublishBrandCampaignStatusChange();

  const toggleModal = () => {
    setBrandCampaignId(null);
    setIsModalOpen(!isModalOpen);
    setFormData({
      campaignName: "",
      campaignCode: "",
      startDate: "",
      endDate: "",
      lockingDate: "",
      campaignType: "",
      outletTypeId: "",
      focusBrands: [],
      sgpiBrands: [],
      isSuspended: "",
      orgUnit: "",

      classifications: [],
      minValues: [],
      maxValues: [],
      position: [],
      description: "",
      materialUrl: "",
      media: "",
      Grades: [],
    });
    setModalStatus("");
    setOrgUnitId(null);
    setSelectedRow("");
    setButtonDisable(false);
  };
  const handleClose = () => {
    setBrandCampaignId(null);
    setIsModalOpen(!isModalOpen);
    setFormData({
      campaignName: "",
      campaignCode: "",
      startDate: "",
      endDate: "",
      lockingDate: "",
      campaignType: "",
      outletTypeId: "",
      focusBrands: [],
      sgpiBrands: [],
      isSuspended: "",
      orgUnit: "",

      classifications: [],
      minValues: [],
      maxValues: [],
      position: [],
      description: "",
      materialUrl: "",
      media: "",
      Grades: [],
    });
    setModalStatus("");
    setOrgUnitId(null);
    setSelectedRow("");
    setButtonDisable(false);
  };

  const handleUpdateBrandCampaign = (row: any, status: string) => {
    console.log("fuctionRow", row);
    setOrgUnitId(row?.OrgUnitId);

    setIsModalOpen(!isModalOpen);
    setModalStatus(status);
    setSelectedRow(row);
    setBrandCampaignId(row?.BrandCampiagnId);
    setShouldOpenModal(true); // flag to open modal when data is ready
  };

  const { data: brandCampaignListData, isLoading: brandCampaignListLoading } =
    useBrandCampaignListData({
      enable: true,
      params: {
        Orgunitid: null,
        search: filtersState.search,
        start: filtersState.start,
        length: filtersState.length,
        sortColumn: "CreatedAt",
        sortOrder: "DESC",
      },
    });

  console.log(
    "🚀 ~ BrandCampagin.tsx:154 ~ BrandCampagin ~ brandCampaignListData:",
    brandCampaignListData
  );

  const handlePagination = (pageNo: number) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        start: pageNo,
      };
    });
  };
  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        start: pageNo,
        length: limit,
      };
    });
  };

  const handleSearch = (searchValue: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        search: searchValue,
      };
    });
  };

  const handleOutletView = (row: any) => {
    navigate("/brandCampaignOutlet", { state: { rowData: row } });
  };

  const handleStepListView = (row: any) => {
    console.log("🚀 ~ BrandCampagin.tsx:187 ~ handleStepListView ~ row:", row);

    navigate("/brandCampaignStep", { state: { rowData: row } });
  };

  const validateCampaignForm = (formData: any, modalStatus: string) => {
    // Helper function: checks if array exists, is not empty, and has no empty values
    const validateArrayField = (arr: any[]) => {
      if (!arr || arr.length === 0) return false;
      return arr.every(
        (val) =>
          val !== null &&
          val !== undefined &&
          (typeof val === "number" ||
            (typeof val === "string" && val.trim() !== ""))
      );
    };
    if (!formData?.campaignName.trim()) {
      return "Please Fill the Campaign Name Field!";
    }
    if (!formData?.description.trim()) {
      return "Please Fill the Description Field!";
    }
    if (!formData?.campaignType) {
      return "Please Fill the Campaign Type Field!";
    }
    if (!formData?.outletTypeId) {
      return "Please Fill the Customer Type Field!";
    }
    if (!formData?.startDate.trim()) {
      return "Please Fill the Start Date Field!";
    }
    if (!formData?.endDate.trim()) {
      return "Please Fill the End Date Field!";
    }
    if (!formData?.lockingDate.trim()) {
      return "Please Fill the Locking Date Field!";
    }
    if (!Number(formData?.orgUnit)) {
      return "Please Select the Org Unit !";
    }
    if (formData?.Grades.length === 0) {
      return "Please Select the Grades !";
    }
    if (formData?.position.length === 0) {
      return "Please Select the Position !";
    }
    if (formData?.classifications.length === 0) {
      return "Please Select the Classifications !";
    }
    // Validate Min Values
    if (!validateArrayField(formData?.minValues)) {
      return "Please fill  Min Values!";
    }

    // Validate Max Values
    if (!validateArrayField(formData?.maxValues)) {
      return "Please fill  Max Values!";
    }

    // ✅ you can also add mode-specific checks
    if (modalStatus === "Update" && !formData?.campaignCode?.trim()) {
      return "Please Fill the Campaign Code Field!";
    }

    return null; // means valid
  };

  const resetForm = () => {
    setFormData({
      campaignName: "",
      campaignCode: "",
      startDate: "",
      endDate: "",
      lockingDate: "",
      campaignType: "",
      outletTypeId: "",
      focusBrands: [],
      sgpiBrands: [],
      isSuspended: "",
      orgUnit: "",
      Grades: [],
      classifications: [],
      minValues: [],
      maxValues: [],
      position: [],
      description: "",
      materialUrl: "",
      media: "",
    });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setButtonDisable(true);
    const error = validateCampaignForm(formData, modalStatus);
    if (error) {
      showToast.warning(error);
      setButtonDisable(false);
      return;
    }

    if (modalStatus === "Update") {
      const updateBody = {
        CampiagnName: formData?.campaignName,
        StartDate: formData?.startDate,
        EndDate: formData?.endDate,
        LockingDate: formData?.lockingDate,
        description: formData?.description,
        CampiagnType: formData?.campaignType,
        OrgUnitId: Number(formData?.orgUnit),
        OutlettypeId: Number(formData?.outletTypeId),
        MaterialUrl: formData?.materialUrl,
        IsSuspended: Number(formData?.isSuspended),
        Position: formData?.position.map((item: any) => item.id),
        Classifications: formData?.classifications,
        minValues: formData?.minValues,
        maxValues: formData?.maxValues,
        FocusBrands: formData?.focusBrands?.map((item: any) => item.id),
        SgpiBrands: formData?.sgpiBrands?.map((item: any) => item.id),
        fileBase: null,
        fileName: null,
        media: formData?.media,
        Grades: formData?.Grades,
      };

      console.log(
        "🚀 ~ BrandCampagin.tsx:298 ~ handleSubmit ~ updateBody:",
        updateBody
      );

      updateBrandCampaign(
        { id: Number(brandCampaignId), body: updateBody },
        {
          onSuccess: () => {
            handleClose();
            resetForm();
            setButtonDisable(false);
          },
          onError: () => {
            setButtonDisable(false);
          },
        }
      );
    } else {
      const addBody = {
        CampiagnName: formData?.campaignName,
        StartDate: formData?.startDate,
        EndDate: formData?.endDate,
        LockingDate: formData?.lockingDate,
        description: formData?.description,
        CampiagnType: formData?.campaignType,
        OrgUnitId: Number(formData?.orgUnit),
        OutlettypeId: Number(formData?.outletTypeId),
        MaterialUrl: formData?.materialUrl,
        IsSuspended: Number(formData?.isSuspended),
        Position: formData?.position.map((item: any) => item.id),
        Classifications: formData?.classifications,
        minValues: formData?.minValues,
        maxValues: formData?.maxValues,
        FocusBrands: formData?.focusBrands?.map((item: any) => item.id),
        SgpiBrands: formData?.sgpiBrands?.map((item: any) => item.id),
        fileBase: null,
        fileName: null,
        media: formData?.media,
        Grades: formData?.Grades,
      };

      console.log(
        "🚀 ~ BrandCampagin.tsx:340 ~ handleSubmit ~ addBody:",
        addBody
      );

      addBrandCampaign(addBody, {
        onSuccess: () => {
          handleClose();
          resetForm();
          setButtonDisable(false);
        },
        onError: () => {
          setButtonDisable(false);
        },
      });
    }
  };

  const handleViewBrandCampaign = (row: any, status: string) => {
    // console.log("ROWWWWW:::::::::::::::::::::", row, status);
    navigate("/brandCampaignView", { state: { rowData: row } });
  };

  const handlePublishBrandCampaign = (row: any, status: string) => {
    // console.log("ROW PUBLISH:::::::::::", row);
    const publishBody = {
      status: "Published",
    };
    publishBrandCampaignStatusChange({
      id: Number(row?.BrandCampiagnId),
      body: publishBody,
    });
  };

  return (
    <div className="p-2">
      <PageHeader
        title="Brand Campaign"
        buttons={[
          {
            label: "+ Add Brand Campaign",
            onClick: toggleModal,
            color: "#2e8dd3",
          },
          {
            label: "Excel",
            onClick: () => alert("Action 2 clicked"),
            color: "#43B9B2",
          },
        ]}
      />

      <BasicDataTable
        Title="Brand Campaign Lists"
        data={brandCampaignListData?.data?.data || []}
        columns={brandCampaginDataColumns(
          handleOutletView,
          handleStepListView,
          handleUpdateBrandCampaign,
          handleViewBrandCampaign,
          handlePublishBrandCampaign
        )}
        showSpinner={brandCampaignListLoading}
        dynamicHeightOnRowsPerPage={true}
        onChangePage={(pageNo: number) => {
          handlePagination(pageNo);
        }}
        onChangeRowsPerPage={(newPerPage: any, page: any) => {
          handleonChangeRowsPerPage(newPerPage, page);
        }}
        handleSearch={(val: any) => {
          handleSearch(val);
        }}
        paginationTotalRows={brandCampaignListData?.data?.recordsTotal || 0}
      />
      <RouteModal
        isOpen={isModalOpen}
        toggle={toggleModal}
        title={modalStatus ? "Edit Campaign" : "Add Campaign"}
        size="xl"
        content={
          modalStatus !== "Update" || orgunitss ? (
            <BrandCampaginModalContent
              handleSubmit={handleSubmit}
              handleClose={handleClose}
              setFormData={setFormData}
              formData={formData}
              modalStatus={modalStatus}
              selectedRow={selectedRow}
              BrandCampaignId={brandCampaignId}
              buttonDisable={buttonDisable}
            />
          ) : (
            <div
              style={{
                padding: "20px",
                textAlign: "center",
                width: "100%",
                height: "100vh",
              }}
            >
              <img src={Loader} alt="Loading..." style={{ height: 40 }} />
            </div>
          )
        }
      />
    </div>
  );
};

export default BrandCampagin;

const brandCampaginDataColumns = (
  handleOutletView: (row: any) => void,
  handleStepListView: (row: any) => void,
  handleUpdateBrandCampaign: (row: any, Status: string) => void,
  handleViewBrandCampaign: (row: any, Status: string) => void,
  handlePublishBrandCampaign: (row: any, Status: string) => void
) => [
  {
    name: "Campaign Name",
    selector: (row: { CampiagnName: number | string }) =>
      row.CampiagnName || "-",
    sortable: true,
    width: "180px",
    wrap: true,
  },
  {
    name: "Type",
    selector: (row: { CampiagnType: string }) => row.CampiagnType || "-",
    sortable: true,
    width: "150px",
    wrap: true,
  },
  {
    name: "Org Unit",
    selector: (row: { UnitName: string }) => row.UnitName || "-",
    sortable: true,
    width: "150px",
    wrap: true,
  },
  {
    name: "Start Date",
    selector: (row: { StartDate: string }) => row.StartDate || "-",
    sortable: true,
    width: "150px",
    wrap: true,
  },
  {
    name: "End Date",
    selector: (row: { EndDate: string }) => row.EndDate || "-",
    sortable: true,
    width: "150px",
    wrap: true,
  },
  {
    name: "Locking Date",
    selector: (row: { LockingDate: string }) => row.LockingDate || "-",
    sortable: true,
    width: "150px",
    wrap: true,
  },
  {
    name: "Status",
    selector: (row: { Status: string }) => row.Status || "-",
    sortable: true,
    width: "150px",
    wrap: true,
  },
  {
    name: "Created At",
    selector: (row: { CreatedAt: string }) =>
      row.CreatedAt
        ? row.CreatedAt.split(".")[0] // removes the .000000
        : "-",
    sortable: true,
    width: "180px",
    wrap: true,
  },
  {
    name: "Action",
    cell: (row: any) => (
      <>
        {row?.Status === "Draft" ? (
          <button
            onClick={() => handleUpdateBrandCampaign(row, "Update")}
            className="btn btn-primary d-flex align-items-center justify-content-center gap-1"
            title="Edit Campaign"
            style={{
              borderRadius: "20px",
              padding: "8px",
              backgroundColor: "#2E8DD3",
            }}
          >
            <FaEdit size={14} style={{ fill: "#fff" }} />
          </button>
        ) : (
          <button
            // onClick={() => handleUpdateBrandCampaign(row, "Update")}
            className="btn btn-primary d-flex align-items-center justify-content-center gap-1"
            style={{
              borderRadius: "20px",
              padding: "8px",
              backgroundColor: "grey",
              borderColor: "grey",
              cursor: "not-allowed",
            }}
          >
            <FaEdit size={14} style={{ fill: "#fff" }} />
          </button>
        )}
        <button
          onClick={() => handleViewBrandCampaign(row, "View")}
          className="btn btn-primary d-flex align-items-center justify-content-center gap-1"
          title="View Campaign"
          style={{
            borderRadius: "20px",
            padding: "8px",
            marginLeft: "8px",
            backgroundColor: "#2E8DD3",
          }}
        >
          <FaEye size={14} style={{ fill: "#fff" }} />
        </button>
        {row?.Status === "Draft" ? (
          <button
            onClick={() => handlePublishBrandCampaign(row, "View")}
            className="btn btn-primary d-flex align-items-center justify-content-center gap-1"
            title="Publish Campaign"
            style={{
              borderRadius: "20px",
              padding: "8px",
              marginLeft: "8px",
              backgroundColor: "#2E8DD3",
              // borderColor: "grey",
            }}
          >
            <FaRegPlayCircle size={14} style={{ fill: "#fff" }} />
          </button>
        ) : (
          <button
            // onClick={() => handlePublishBrandCampaign(row, "View")}
            className="btn btn-primary d-flex align-items-center justify-content-center gap-1"
            style={{
              borderRadius: "20px",
              padding: "8px",
              marginLeft: "8px",
              backgroundColor: "grey",
              borderColor: "grey",
              cursor: "not-allowed",
            }}
          >
            <FaRegPlayCircle size={14} style={{ fill: "#fff" }} />
          </button>
        )}

        {row?.Status === "Published" || row?.Status === "Started" ? (
          <button
            onClick={() => handleOutletView(row)}
            className="btn btn-primary d-flex align-items-center justify-content-center gap-1"
            style={{
              borderRadius: "20px",
              padding: "8px",
              marginLeft: "8px",
              backgroundColor: "#2E8DD3",
            }}
            title="Campaign Outlet"
          >
            {/* <FaEye size={14} style={{ fill: "#fff" }} /> Outlet */}
            <LiaStoreAltSolid size={14} style={{ fill: "#fff" }} />
          </button>
        ) : (
          <button
            // onClick={() => handleOutletView(row)}
            className="btn btn-primary d-flex align-items-center justify-content-center gap-1"
            style={{
              borderRadius: "20px",
              padding: "8px",
              marginLeft: "8px",
              backgroundColor: "grey",
              borderColor: "grey",
              cursor: "not-allowed",
            }}
          >
            {/* <FaEye size={14} style={{ fill: "#fff" }} /> Outlet */}
            <LiaStoreAltSolid size={14} style={{ fill: "#fff" }} />
          </button>
        )}

        {row?.Status === "Published" ||
        row?.Status === "Started" ||
        row?.Status === "Draft" ? (
          <button
            onClick={() => handleStepListView(row)}
            className="btn btn-primary d-flex align-items-center justify-content-center gap-1"
            style={{
              borderRadius: "20px",
              padding: "8px",
              marginLeft: "8px",
              backgroundColor: "#2E8DD3",
            }}
            title="Campaign Steps"
          >
            {/* <FaEye size={14} style={{ fill: "#fff" }} /> Step */}
            <BsSortNumericUp size={14} style={{ fill: "#fff" }} />
          </button>
        ) : (
          <button
            // onClick={() => handleStepListView(row)}
            className="btn btn-primary d-flex align-items-center justify-content-center gap-1"
            style={{
              borderRadius: "20px",
              padding: "8px",
              marginLeft: "8px",
              backgroundColor: "grey",
              borderColor: "grey",
              cursor: "not-allowed",
            }}
          >
            {/* <FaEye size={14} style={{ fill: "#fff" }} /> Step */}
            <BsSortNumericUp size={14} style={{ fill: "#fff" }} />
          </button>
        )}
      </>
    ),
  },
];
